import debug from 'debug';

export const log = debug('@jsdocs-io/extractor');
